import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  container: {
    marginTop: 30,
    marginBottom: 30,
  },
  typography: {
    color: "#0000008a",
  },
  typographyNewUser: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#000000",
  },
  accordionTitle: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "19px",
    color: "#000000",
  },
  accordionItemsOldUser: {
    boxShadow: "none",
  },
  accordionItems: {
    borderTop: "1px solid #E6E6E6",
    boxShadow: "none",
  },
  accordionIcon: {
    color: "#F15A28",
    borderRadius: "30px",
    width: "33px",
    height: "33px",
    left: "1083px",
    top: "289px",
    "&:hover": {
      backgroundColor: "#FEEFEA",
    },
  },
  accordionItem: {
    marginTop: "29px",
  },
  buttonLoad: {
    margin: "auto",
    display: "flex",
    padding: "12px 24px",
    background: "#F1F5FF",
    color: "#0344DC",
    borderRadius: "100px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "19px",
  },
});
